import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { LocationCardComponent } from 'src/app/location/components/location-card/location-card.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-content-block-locations',
  standalone: true,
  imports: [LocationCardComponent, CommonModule],
  templateUrl: './content-block-locations.component.html',
  styleUrl: './content-block-locations.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlocklocationsComponent extends ContentBlockBaseComponent {
  isGrid = computed(() => (this.block().locations?.length || 0) > 3);

  featuredLocation = computed(() => {
    const locations = this.block().locations || [];
    return this.isGrid() ? locations.filter(location => location.id === 1)?.[0] : null;
  });

  locations = computed(() => {
    const locations = this.block().locations || [];
    // id 1 = CODA centrum
    return this.isGrid() ? locations.filter(location => location.id !== 1) : locations;
  });
}
